import $http from "../../../../axios-instance";

/**
 * Cargar las palabras de advertencia de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} state - Estado de las palabras de advertencia de SGA.
 * @author Brandon Torres
 */
export async function getWordsOfCautionSga(
    { commit, state }
) {
    commit("dashboard/load", true, { root: true });
    try {
        const { name } = state.filterWordsOfCautionSga;

        const { data: response } = await $http.get("sga/word-of-caution-list", {
            params: {
                search: name,
            },
        });
        commit("setWordsOfCautionSga", response.data);
        commit("setPaginateWordsOfCautionSga", response.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Crear una nueva palabra de advertencia de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} wordOfCaution - Palabra de advertencia de SGA.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function createWordOfCautionSga({ commit }, wordOfCaution) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.post(
            "sga/word-of-caution-create",
            wordOfCaution
        );
        this.$vue.$alertSuccess(response.data.message);
        return true;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cambiar el estado de una palabra de advertencia de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} id - Identificador de la palabra de advertencia de SGA.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function changeStatusWordOfCautionSga({ commit }, id) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.put(
            `sga/word-of-caution-change-status/${id}`
        );
        this.$vue.$alertSuccess(response.data.message);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Actualizar una palabra de advertencia de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} wordOfCaution - Palabra de advertencia de SGA.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function updateWordOfCautionSga({ commit }, wordOfCaution) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.put(
            `sga/word-of-caution-update/${wordOfCaution.id}`,
            wordOfCaution
        );
        this.$vue.$alertSuccess(response.data.message);
        return true;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}


/**
 * Actualizar las prioridades de las palabra de advertencia de SGA.
 *
 * @param Object commit - Función de Vuex para llamar a una mutación.
 * @param Array words - Palabras de advertencia de SGA.
 */
export async function updatePrioritiesWords({ commit }, words) {
    commit("dashboard/load", true, { root: true });
    try {

        const response = await $http.put(`sga/word-of-caution/change-priority`, words);
        this.$vue.$alertSuccess(response.data.message);
        
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cargar las palabras de advertencia activas de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function getActiveWordsOfCautionSga({ commit }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.get("sga/word-of-caution-list-actives");
        commit("setActiveWordsOfCautionSga", response.data.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cargar la palabra de advertencia de SGA segun su id.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} id - Identificador de la palabra de advertencia de SGA.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function showWordOfCautionSga({ commit }, id) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.get(`sga/word-of-caution-show/${id}`);
        commit("setWordOfCautionSga", response.data.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Sincronizar los lenguajes de las palabra de advertencia de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function asyncLanguagesWordsOfCautionSga({ commit }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.post("sga/word-of-caution-translate-all");
        this.$vue.$alertSuccess(response.data.message);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}
